:host {
  display: block;
}

hr {
  width: 100%;
  max-width: 1600px;
  border: none;
  height: 1px;
  background: var(--color-silver);
}
